﻿export function setupSearchPageForm() {

    $(document).on('change', '[data-search-page-form] select', function () {
        this.form.submit();
    });
}
